define( [
	"./arr"
], function( arr ) {
	return arr.push;
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/var/push.js
 ** module id = 423
 ** module chunks = 2
 **/